import { SourceDetails } from 'features/layout/types';
import { ExternalStreamingStarted } from 'features/streaming/types';

export const getVideoStreamLayerCount = (streams: ExternalStreamingStarted['streams']) =>
  streams.find((stream) => stream.type === 'video')?.layerCount ?? 1;

export const sourceMatches = (
  sourceA?: Omit<SourceDetails, 'kind'> | null,
  sourceB?: Omit<SourceDetails, 'kind'> | null
) => sourceA?.userId === sourceB?.userId && sourceA?.feedId === sourceB?.feedId;

export const makeSourceKey = (source: SourceDetails) => `${source.userId}-${source.kind}`;
